import React, { useState } from "react";
import { RiAddFill } from "react-icons/ri";
import { RxCross2 } from "react-icons/rx";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import GroupPostModal from "./GroupPostModal";

const PollModal = ({ pollOpen, pollcloseModal,groupdata,groupowner, onGroupCreated }) => {
  const [pollData, setPollData] = useState({
    question: "",
    options: ["", ""], 
    duration: 7,
  });
  const [modalOpen, setModalOpen] = useState(false);
  const handleChange = (event) => {
    setPollData((prevData) => ({
      ...prevData,
      duration: event.target.value,
    }));
  };

  const handleQuestionChange = (event) => {
    setPollData((prevData) => ({
      ...prevData,
      question: event.target.value,
    }));
  };

  const handleOptionChange = (index, value) => {
    const updatedOptions = [...pollData.options];
    updatedOptions[index] = value;
    setPollData((prevData) => ({
      ...prevData,
      options: updatedOptions,
    }));
  };

  const addOption = () => {
    if (pollData.options.length < 4) {
      setPollData((prevData) => ({
        ...prevData,
        options: [...prevData.options, ""],
      }));
    }
  };

  const removeOption = (index) => {
    const updatedOptions = pollData.options.filter((_, i) => i !== index);
    setPollData((prevData) => ({
      ...prevData,
      options: updatedOptions,
    }));
  };

  const isFormValid =
    pollData.question.trim() !== "" &&
    pollData.options[0].trim() !== "" &&
    pollData.options[1].trim() !== "";

  const handleSubmit = () => {
    setModalOpen(true);
    console.log("Poll Data Submitted:", pollData);
  };

  return (
    <>
      {pollOpen && (
        <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50">
          <div className="modal-dialog bg-white rounded-[30px] shadow-lg max-w-xl w-full border-8 border-gray-500">
            <div className="modal-content border-[#F16163]">
              <div className="modal-header bg-white flex justify-between items-center rounded-t-[30px] py-4 px-5 border-b">
                <div className="flex items-start text-xl font-semibold">
                  Create a poll
                </div>
                <button
                  type="button"
                  className="text-xl text-gray-500 bg-gray-100 p-2 rounded-full"
                  onClick={pollcloseModal}
                >
                  <RxCross2 />
                </button>
              </div>
              <div className="py-4 px-5 overflow-y-auto max-h-[500px]">
                <div className="flex flex-col">
                  <label>
                    Your question<span className="text-red-500">*</span>
                  </label>
                  <textarea
                    className="border border-gray-400 rounded-md p-1 text-sm"
                    rows={2}
                    placeholder="E.g., How do you commute to work?"
                    value={pollData.question}
                    onChange={handleQuestionChange}
                  />
                </div>
                {pollData.options.map((option, index) => (
                  <div key={index} className="flex flex-col my-6">
                    <label className="flex justify-between">
                      <div>
                        Option {index + 1} <span className="text-red-500">*</span>
                      </div>
                      {index >= 2 && (
                        <button
                          className="text-blue-700 font-semibold"
                          onClick={() => removeOption(index)}
                        >
                          Remove
                        </button>
                      )}
                    </label>
                    <textarea
                      className="border border-gray-400 rounded-md p-1 text-sm"
                      rows={1}
                      placeholder={`Enter option ${index + 1}`}
                      value={option}
                      onChange={(e) => handleOptionChange(index, e.target.value)}
                    />
                  </div>
                ))}
                {pollData.options.length < 4 && (
                  <button
                    className="flex items-center justify-between space-x-1 bg-white border border-blue-500 text-blue-500 px-2 py-1 rounded-3xl hover:border-blue-800 hover:bg-blue-100 hover:text-blue-800 hover:border-2"
                    onClick={addOption}
                  >
                    <RiAddFill className="text-xl" /> <p>Add Option</p>
                  </button>
                )}
                <div className="flex flex-col space-y-3 my-6">
                  <label>Poll duration</label>
                  <FormControl sx={{ m: 0, minWidth: "100%", width: "100%", padding: 0 }}>
                    <Select
                      value={pollData.duration}
                      onChange={handleChange}
                      displayEmpty
                      inputProps={{ "aria-label": "Without label" }}
                      className="p-0 h-8"
                      sx={{
                        padding: 0,
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "gray",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "gray",
                        },
                      }}
                    >
                      <MenuItem value={1}>1 day</MenuItem>
                      <MenuItem value={2}>3 days</MenuItem>
                      <MenuItem value={7}>1 week</MenuItem>
                      <MenuItem value={21}>3 weeks</MenuItem>
                    </Select>
                  </FormControl>
                </div>
                <p className="text-sm">
                  We don’t allow requests for political opinions, medical information, or other sensitive data.
                </p>
              </div>

              <div className="border-t">
                <div className="flex justify-end space-x-2 py-4 px-5">
                  <button
                    className="bg-white text-blue-500 border border-blue-500 px-4 py-1 rounded-3xl"
                    onClick={pollcloseModal}
                  >
                    Back
                  </button>
                  <button
                    className={`px-4 py-1 rounded-3xl ${
                      isFormValid ? "bg-blue-500 text-white" : "bg-gray-300 text-gray-500 cursor-not-allowed"
                    }`}
                    disabled={!isFormValid}
                    onClick={handleSubmit}
                  >
                    Done
                  </button>
                </div>
              </div>
            </div>
          </div>
          {modalOpen &&
          <GroupPostModal
             modalOpen={modalOpen}
             closeModal={() => setModalOpen(false)}
             pollcloseModal={pollcloseModal}
             onGroupCreated={onGroupCreated}
             groupdata={groupdata}
             groupowner={groupowner}
             pollData={pollData}
          />
        }
        </div>
      )}
    </>
  );
};

export default PollModal;
